import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";

const AboutPreview = () => {
  return (
    <section className="bg-gray-50 py-16 md:py-24">
      <div className="container mx-auto px-6 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="relative">
              <div className="rounded-3xl overflow-hidden">
                <img
                  src="https://images.unsplash.com/photo-1622253692010-333f2da6031d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2064&q=80"
                  alt="Dr. Danijel Novak"
                  className="w-full h-auto object-cover opacity-0 animate-fade-in"
                  style={{ height: "500px" }}
                />
              </div>
              <div className="absolute -bottom-6 -right-6 glass-pink p-6 rounded-3xl max-w-xs opacity-0 animate-fade-in animate-delay-200">
                <p className="text-gray-800 font-medium">
                  "Moja filozofija je ustvariti naravne rezultate, ki poudarijo vašo lepoto in samozavest."
                </p>
                <p className="text-medical-600 mt-2 font-medium">
                  — Dr. Danijel Novak
                </p>
              </div>
            </div>
          </div>
          
          <div className="space-y-6 opacity-0 animate-fade-in">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
              Dr. Danijel Novak
            </h2>
            <p className="text-xl text-medical-600 font-medium">
              Specialist plastične, rekonstruktivne in estetske kirurgije
            </p>
            <p className="text-gray-700">
              Z več kot 15 let izkušenj na področju plastične, rekonstruktivne in estetske kirurgije, dr. Novak združuje umetnost in znanost za doseganje naravnih, harmoničnih rezultatov. Njegovo strokovno znanje in natančnost sta ga uveljavila kot enega vodilnih kirurgov v Sloveniji.
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2">
              <div className="flex items-start">
                <div className="bg-medical-100 p-1.5 rounded-full text-medical-600 mr-3">
                  <Check size={16} />
                </div>
                <span className="text-gray-700">15+ let izkušenj</span>
              </div>
              <div className="flex items-start">
                <div className="bg-medical-100 p-1.5 rounded-full text-medical-600 mr-3">
                  <Check size={16} />
                </div>
                <span className="text-gray-700">Mednarodno izobražen</span>
              </div>
              <div className="flex items-start">
                <div className="bg-medical-100 p-1.5 rounded-full text-medical-600 mr-3">
                  <Check size={16} />
                </div>
                <span className="text-gray-700">Napredne tehnike</span>
              </div>
              <div className="flex items-start">
                <div className="bg-medical-100 p-1.5 rounded-full text-medical-600 mr-3">
                  <Check size={16} />
                </div>
                <span className="text-gray-700">Individualen pristop</span>
              </div>
            </div>
            
            <div className="pt-4">
              <Button asChild className="bg-medical-500 hover:bg-medical-600 text-white rounded-full btn-hover-effect">
                <Link to="/o-nas">Več o Dr. Novaku</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutPreview;